// assets/custom-cart-refresh.js
// COMPLETE: cart refresh + section-rendering + aggressive sanitizer + prevention + checkout-cleaner
// - updates cart counts/drawer after add-to-cart
// - applies returned section HTML fragments if available
// - aggressively removes bracketed currency and price tokens from cart line-item properties
// - specifically strips trailing bracketed prices from <dd> lines containing Height/Width
// - prevents sending bracketed prices in property inputs for future adds
// - cleans existing cart items server-side before navigating to checkout (remove/re-add cleaned items)

(function() {
  // ===== CONFIG =====
  var ADD_BUTTON_SELECTOR = '[data-option-calculator-add], .option-calculator-add-to-cart, .option-calculator-add-btn, button.add-to-cart, .product-form__submit, .product-form__add-to-cart';
  var CART_DRAWER_INNER_SELECTOR = '.cart-drawer__inner';
  var CART_ITEM_PROPERTY_SELECTORS = [
    '.cart-item__properties',
    '.cart-line__properties',
    '.cart-property',
    '.cart__property',
    '.cart-item__meta',
    '.line-item-properties',
    '.cart-item-properties'
  ];
  var CART_BUBBLE_SELECTOR = '.cart-bubble__text-count';
  var CART_ICON_SELECTOR = '.header-cart, .js-show-cart, [data-cart-open], .cart-toggle, .cart-button';
  var WAIT_AFTER_CLICK = 700; // ms - increase if needed

  // -----------------------
  // PREVENT sending bracketed price into property inputs (for FUTURE adds)
  // -----------------------
  function sanitizePropertyInputs(root) {
    try {
      (root || document).querySelectorAll('input[name*="properties"], textarea[name*="properties"]').forEach(function(el){
        if (!el || !el.value) return;
        var v = el.value;
        v = v.replace(/\s*\[[^\]]*?\]\s*$/m, ''); // remove trailing [ ... ]
        v = v.replace(/\s*\([^\)]*?(?:₹|Rs|INR|\$|£|€)[^\)]*?\)\s*$/mi, ''); // remove trailing (₹...)
        v = v.replace(/[\s\-\—\•]*[₹$£€]\s*[0-9,\.]+\s*$/m, ''); // remove " - ₹123"
        v = v.replace(/\b(INR|Rs\.?|Rs)\s*[0-9,\.]+\s*$/i, ''); // remove INR/Rs
        if (v !== el.value) el.value = v;
      });
    } catch (e) {
      console.warn('sanitizePropertyInputs error', e);
    }
  }

  document.addEventListener('submit', function(ev){
    var form = ev.target;
    if (!form) return;
    if (form.querySelector && form.querySelector('input[name*="properties"], textarea[name*="properties"]')) {
      sanitizePropertyInputs(form);
    }
  }, true);

  document.addEventListener('click', function(ev){
    var btn = ev.target.closest('button, input[type="submit"], a');
    if (!btn) return;
    sanitizePropertyInputs(document);
  }, true);

  // -----------------------
  // AGGRESSIVE SANITIZER utilities
  // -----------------------
  function sanitizePropertyElement(container) {
    if (!container) return;
    container.querySelectorAll('span, i, b, strong').forEach(function(child){
      try {
        var text = (child.textContent || '').trim();
        if (!text) return;
        if (/[₹$£€]|INR|Rs\.?/i.test(text) && /[0-9]/.test(text)) child.remove();
      } catch(e){}
    });

    try {
      var html = container.innerHTML;
      var newHtml = html;
      newHtml = newHtml.replace(/\s*\[[^\]]*?\]\s*$/m, ''); // trailing [..]
      newHtml = newHtml.replace(/\s*\([^\)]*?(?:₹|Rs|INR|\$|£|€)[^\)]*?\)\s*$/mi, ''); // trailing (.. currency ..)
      newHtml = newHtml.replace(/[\s\-\—\•]*[₹$£€]\s*[0-9,\.]+(?:\s*[A-Za-z]{0,3})?\s*$/m, ''); // trailing direct currency
      newHtml = newHtml.replace(/\b(INR|Rs\.?|Rs)\s*[0-9,\.]+\s*$/i, ''); // trailing INR/Rs
      newHtml = newHtml.replace(/\|\s*[₹$£€]\s*[0-9,\.]+\s*$/m, ''); // trailing "| ₹.."
      if (newHtml !== html) container.innerHTML = newHtml;
    } catch (e) {
      console.warn('sanitizePropertyElement regex error', e);
    }
  }

  function stripBracketedPrices(rootEl) {
    if (!rootEl) return;
    try {
      CART_ITEM_PROPERTY_SELECTORS.forEach(function(sel) {
        rootEl.querySelectorAll(sel).forEach(function(container) {
          sanitizePropertyElement(container);
        });
      });
    } catch (e) { console.warn('stripBracketedPrices error', e); }
  }

  // targeted dd stripper for "Height/Width" lines
  function stripBracketedFromDDs(root) {
    if (!root) root = document;
    try {
      root.querySelectorAll('dd').forEach(function(dd){
        var text = (dd.textContent || '').trim();
        if (!/Height:|Width:/i.test(text)) return;
        var newText = text.replace(/\s*\[[^\]]*?\]\s*$/m, '');
        newText = newText.replace(/\s*\([^\)]*?(?:₹|Rs|INR|\$|£|€)[^\)]*?\)\s*$/mi, '');
        newText = newText.replace(/[\s\-\—\•]*[₹$£€]\s*[0-9,\.]+\s*$/m, '');
        newText = newText.replace(/\b(INR|Rs\.?|Rs)\s*[0-9,\.]+\s*$/i, '');
        if (newText !== text) dd.textContent = newText;
      });
    } catch (e) { console.warn('stripBracketedFromDDs failed', e); }
  }

  // Observe a node for mutations and sanitize whenever changes occur
  function observeAndSanitize(rootNode) {
    if (!rootNode) return null;
    try {
      var mo = new MutationObserver(function() {
        stripBracketedPrices(rootNode);
        stripBracketedFromDDs(rootNode);
      });
      mo.observe(rootNode, { childList: true, subtree: true, characterData: true });
      stripBracketedPrices(rootNode);
      stripBracketedFromDDs(rootNode);
      return mo;
    } catch (e) { console.warn('observeAndSanitize failed', e); return null; }
  }

  // -----------------------
  // CART REFRESH helpers
  // -----------------------
  function refreshCartUI(openDrawer) {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var count = cart.item_count || 0;
        document.querySelectorAll('[data-cart-count], .cart-count, .js-cart-count, .header__cart-count, ' + CART_BUBBLE_SELECTOR)
          .forEach(function(el) {
            try {
              if ('value' in el) el.value = count; else el.textContent = count;
              el.dispatchEvent(new Event('cart:count:changed', { bubbles: true }));
            } catch(e){}
          });

        stripBracketedPrices(document);
        stripBracketedFromDDs(document);

        window.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        if (openDrawer) tryOpenCart();
      })
      .catch(function(e){ console.warn('refreshCartUI failed', e); });
  }

  function tryOpenCart() {
    try { if (window.theme && typeof window.theme.openCart === 'function') window.theme.openCart(); } catch(e){}
    try { if (window.cart && typeof window.cart.open === 'function') window.cart.open(); } catch(e){}
    try { if (typeof window.openCart === 'function') window.openCart(); } catch(e){}
    var btn = document.querySelector(CART_ICON_SELECTOR);
    if (btn) { try { btn.click(); } catch(e){} }
  }

  // -----------------------
  // Section-rendering update: apply returned section HTML fragments (Shopify-style)
  // -----------------------
  function applySectionHtmlSections(sectionsObj) {
    if (!sectionsObj) return;
    try {
      Object.entries(sectionsObj).forEach(function(pair) {
        var html = pair[1];
        if (!html) return;
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        var updatedCartContent = doc.querySelector(CART_DRAWER_INNER_SELECTOR);
        var cartDrawer = document.querySelector(CART_DRAWER_INNER_SELECTOR);
        if (cartDrawer && updatedCartContent) {
          cartDrawer.innerHTML = updatedCartContent.innerHTML;
          stripBracketedPrices(cartDrawer);
          stripBracketedFromDDs(cartDrawer);
          observeAndSanitize(cartDrawer);
        }

        var updatedCartBubble = doc.querySelector(CART_BUBBLE_SELECTOR);
        var cartBubble = document.querySelector(CART_BUBBLE_SELECTOR);
        if (cartBubble && updatedCartBubble) {
          cartBubble.innerHTML = updatedCartBubble.innerHTML;
          cartBubble.dispatchEvent(new Event('cart:count:changed', { bubbles: true }));
        }
      });
    } catch (err) { console.warn('applySectionHtmlSections error', err); }
  }

  // -----------------------
  // Main handler after add-to-cart completes
  // -----------------------
  function handleAfterAdd(response) {
    if (response && response.sections) {
      applySectionHtmlSections(response.sections);
      refreshCartUI(false);
      tryOpenCart();
      return;
    }

    // Best-effort: fetch header & cart-drawer HTML and apply replacements
    fetch(window.location.pathname + '?sections=header,cart-drawer', { credentials: 'same-origin' })
      .then(function(r) { return r.text(); })
      .then(function(htmlText) {
        try {
          var parser = new DOMParser();
          var doc = parser.parseFromString(htmlText, 'text/html');
          var sectionsObj = {};
          var header = doc.querySelector('header');
          if (header) sectionsObj.header = header.outerHTML;
          var cartDrawer = doc.querySelector(CART_DRAWER_INNER_SELECTOR);
          if (cartDrawer) sectionsObj['cart-drawer'] = '<div class="' + CART_DRAWER_INNER_SELECTOR.replace('.', '') + '">' + cartDrawer.innerHTML + '</div>';

          if (Object.keys(sectionsObj).length) {
            handleAfterAdd({ sections: sectionsObj });
          } else {
            refreshCartUI(true);
          }
        } catch (err) {
          refreshCartUI(true);
        }
      })
      .catch(function() {
        refreshCartUI(true);
      });
  }

  // -----------------------
  // Click delegation: detect add-to-cart clicks and trigger refresh
  // -----------------------
  document.addEventListener('click', function(ev) {
    var btn = ev.target.closest(ADD_BUTTON_SELECTOR);
    if (!btn) return;
    setTimeout(function() { handleAfterAdd(null); }, WAIT_AFTER_CLICK);
  }, true);

  // Listen for app-specific events (if app emits them)
  window.addEventListener('option_calculator_added', function(e) { handleAfterAdd(e.detail || null); });
  window.addEventListener('optionCalculator:added', function(e) { handleAfterAdd(e.detail || null); });
  window.addEventListener('app:cart:add:finish', function(e) { handleAfterAdd(e.detail || null); });

  // Observe existing nodes and initial sanitize
  document.addEventListener('DOMContentLoaded', function() {
    var drawer = document.querySelector(CART_DRAWER_INNER_SELECTOR);
    if (drawer) observeAndSanitize(drawer);
    CART_ITEM_PROPERTY_SELECTORS.forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(el) { observeAndSanitize(el); });
    });
    stripBracketedPrices(document);
    stripBracketedFromDDs(document);
  });

  // -----------------------
  // CLEAN CART BEFORE CHECKOUT - runs when checkout clicked
  // -----------------------
  (function(){
    var CHECKOUT_SELECTORS = [
      'form[action$="/cart"] [name="checkout"]',
      'a[href$="/checkout"]',
      '.cart__checkout, .cart__checkout-button, .btn--checkout, .button--checkout',
      '.drawer .checkout-link, .cart-drawer .cart__checkout'
    ];

    function hasPriceText(str){
      if(!str) return false;
      return /\[[^\]]*\]$/.test(str.trim())
        || /\b(INR|Rs\.?|Rs)\b/i.test(str)
        || /[₹$£€]\s*[0-9,\.]+/.test(str);
    }

    function cleanPropertyValue(val){
      if(!val) return val;
      var out = val.replace(/\s*\[[^\]]*?\]\s*$/m, '');
      out = out.replace(/\s*\([^\)]*?(?:₹|Rs|INR|\$|£|€)[^\)]*?\)\s*$/mi, '');
      out = out.replace(/[\s\-\—\•]*[₹$£€]\s*[0-9,\.]+\s*$/m, '');
      out = out.replace(/\b(INR|Rs\.?|Rs)\s*[0-9,\.]*\s*$/i, '');
      return out.trim();
    }

    function attachCheckoutCleaner() {
      document.addEventListener('click', function(ev){
        var el = ev.target.closest(CHECKOUT_SELECTORS.join(','));
        if(!el) return;
        ev.preventDefault();
        ev.stopPropagation();
        cleanCartThenProceed(function(success, checkoutUrl){
          window.location.href = checkoutUrl || '/checkout';
        });
      }, { capture: true });
    }

    function cleanCartThenProceed(callback) {
      fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json()).then(function(cart){
        var items = cart.items || [];
        var toClean = [];
        items.forEach(function(item){
          var needs = false;
          var cleanedProperties = {};
          if (item.properties) {
            Object.keys(item.properties).forEach(function(k){
              var v = item.properties[k];
              if (hasPriceText(String(v || ''))) needs = true;
              cleanedProperties[k] = cleanPropertyValue(String(v || ''));
            });
          }
          if (needs) {
            toClean.push({
              key: item.key,
              variant_id: item.variant_id,
              quantity: item.quantity,
              cleanedProperties: cleanedProperties
            });
          }
        });

        if (!toClean.length) return callback(true, null);

        var index = 0;
        function processNext(){
          if (index >= toClean.length) return callback(true, null);
          var entry = toClean[index++];

          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ id: entry.key, quantity: 0 })
          })
          .then(function(r){ return r.json(); })
          .then(function(){
            var body = { id: entry.variant_id, quantity: entry.quantity };
            if (entry.cleanedProperties && Object.keys(entry.cleanedProperties).length) body.properties = entry.cleanedProperties;
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify(body)
            });
          })
          .then(function(r){ return r.json(); })
          .then(function(){
            setTimeout(processNext, 200);
          })
          .catch(function(err){
            console.warn('cleanCartThenProceed error for', entry, err);
            setTimeout(processNext, 200);
          });
        }

        processNext();

      }).catch(function(err){
        console.warn('Failed to fetch /cart.js for cleaning', err);
        callback(false, null);
      });
    }

    attachCheckoutCleaner();
    window.__cleanCartThenProceed = cleanCartThenProceed;
  })();

  // Expose manual helper for debugging
  window.__customCartRefresh = function(response) { handleAfterAdd(response || null); };

})();
